export enum PerformanceTestSeriesEnum {
  SummarizerHeadlineSmall = "SUMMARIZER_HEADLINE_SMALL",
}
